<div class="row billet-actions">
  <ng-container *ngIf="!isBilletChart; else elseTemplate">
    <div class="col-4 p-0">
      <button mat-raised-button color="buy" (click)="sendOrder(SideEnum.BUY, true)">C. Mercado</button>
    </div>
    <div class="col-4 p-0">
      <button mat-raised-button color="clear" (click)="clearPosition()">Zerar</button>
    </div>
    <div class="col-4 p-0">
      <button mat-raised-button color="sell" (click)="sendOrder(SideEnum.SELL, true)">V. Mercado</button>
    </div>
    <div class="col-4 p-0">
      <button mat-raised-button color="buy" (click)="sendOrder(SideEnum.BUY)">Comprar</button>
    </div>
    <div class="col-4 p-0">
      <button mat-raised-button color="clear-all" (click)="cancelAllOrder()">Canc. Todas</button>
    </div>
    <div class="col-4 p-0">
      <button mat-raised-button color="sell" (click)="sendOrder(SideEnum.SELL)">Vender</button>
    </div>
  </ng-container>
  <ng-template #elseTemplate>
    <div class="col-6 p-0">
      <button mat-raised-button color="buy" (click)="sendOrder(SideEnum.BUY, true)">C. Mercado</button>
    </div>
    <div class="col-6 p-0">
      <button mat-raised-button color="sell" (click)="sendOrder(SideEnum.SELL, true)">V. Mercado</button>
    </div>
    <div class="col-6 p-0">
      <button mat-raised-button color="buy" (click)="sendOrder(SideEnum.BUY)">Comprar</button>
    </div>
    <div class="col-6 p-0">
      <button mat-raised-button color="sell" (click)="sendOrder(SideEnum.SELL)">Vender</button>
    </div>
    <div class="col-6 p-0">
      <button mat-raised-button color="clear" (click)="clearPosition()">Zerar</button>
    </div>
    <div class="col-6 p-0">
      <button mat-raised-button color="clear-all" (click)="cancelAllOrder()">Canc. Todas</button>
    </div>
  </ng-template>
</div>
